import fetch from "auth/FetchInterceptor";

const contasPowerBiService = {};

contasPowerBiService.getAll = function () {
	return fetch({
		url: "/v1/rest/contas-power-bi",
		method: "get",
	});
};

contasPowerBiService.getById = function (id) {
	return fetch({
		url: `/v1/rest/contas-power-bi/${id}`,
		method: "get",
	});
};

contasPowerBiService.post = function (data) {
	return fetch({
		url: "/v1/rest/contas-power-bi",
		method: "post",
		data: data,
	});
};

contasPowerBiService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/contas-power-bi/${id}`,
		method: "put",
		data: data,
	});
};

contasPowerBiService.delete = function (id) {
	return fetch({
		url: `/v1/rest/contas-power-bi/${id}`,
		method: "delete",
	});
};

export default contasPowerBiService;
